import React from 'react';
export function Footer() {
  return <footer className="bg-black border-t border-zinc-800 py-12 pt-[1px] pb-[1px]" data-id="element-103">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-104">
        <div className="max-w-6xl mx-auto" data-id="element-105">
          <div className="text-center mb-8" data-id="element-106">
            <h3 className="text-2xl font-black text-white uppercase mb-2" data-id="element-107">
              Plan Anti Panza
            </h3>
            <p className="text-zinc-500 text-sm" data-id="element-108">
              Sistema digital de 12 semanas para bajar grasa
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-109">
            <a href="#" className="text-zinc-400 hover:text-white transition-colors" data-id="element-110">
              Términos y Condiciones
            </a>
            <a href="#" className="text-zinc-400 hover:text-white transition-colors" data-id="element-111">
              Política de Privacidad
            </a>
            <a href="#" className="text-zinc-400 hover:text-white transition-colors" data-id="element-112">
              Contacto
            </a>
            <a href="#" className="text-zinc-400 hover:text-white transition-colors" data-id="element-113">
              Garantía
            </a>
          </div>

          <div className="text-center text-zinc-600 text-sm" data-id="element-114">
            <p data-id="element-115">© 2026 Plan Anti Panza. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>;
}